(function ($) {
  $(function () {
    $('[data-swap-main-image]').on('click', function () {
      var $this = $(this);
      var newImageSrc = $this.data('swap-main-image');
		
      $('[data-swap-image-target]').attr('src', newImageSrc);
    });
  });
}(jQuery));
